import { Chart } from 'primereact/chart';
import { Card } from 'primereact/card';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { useEffect, useState } from 'react';

const TokenomicsSection = () => {
  const [chartData, setChartData] = useState({});
  const [chartOptions, setChartOptions] = useState({});

  useEffect(() => {
    const documentStyle = getComputedStyle(document.documentElement);
    const data = {
      labels: ['Community (87.75%)', 'Team & Dev (7%)', 'Marketing (3%)', 'Ecosystem Fund (2.25%)'],
      datasets: [
        {
          data: [877500000, 70000000, 30000000, 22500000],
          backgroundColor: [
            documentStyle.getPropertyValue('--yellow-500'),
            documentStyle.getPropertyValue('--blue-500'),
            documentStyle.getPropertyValue('--red-500'),
            documentStyle.getPropertyValue('--green-500'),
          ],
          hoverBackgroundColor: [
            documentStyle.getPropertyValue('--yellow-400'),
            documentStyle.getPropertyValue('--blue-400'),
            documentStyle.getPropertyValue('--red-400'),
            documentStyle.getPropertyValue('--green-400'),
          ]
        }
      ]
    };
    
    const options = {
      cutout: '60%',
      plugins: {
        legend: {
          position: 'bottom',
          labels: {
            usePointStyle: true
          }
        }
      }
    };

    setChartData(data);
    setChartOptions(options);
  }, []);

  const allocationDetails = [
    {
      label: 'Community Allocation',
      percentage: '87.75%',
      color: 'bg-yellow-500',
      headerNote: '', // no lock/vesting for community
      content: `The majority of EON tokens (87.75%) are allocated to the community through a fair launch on Pump.fun. This ensures decentralized distribution where early supporters and collectors are rewarded proportionally to their engagement with the ecosystem.`
    },
    {
      label: 'Team & Development',
      percentage: '7%',
      color: 'bg-blue-500',
      headerNote: '🔒 Locked & vested quarterly for 3 years',
      content: `Funds dedicated to the core team and platform development:
• Core team compensation
• Platform maintenance
• Future game and feature development`
    },
    {
      label: 'Marketing & Growth',
      percentage: '3%',
      color: 'bg-red-500',
      headerNote: '🔒 50% (15,000,000) Locked & vested quarterly for 3 years',
      content: `Strategic allocation for ecosystem growth:
• Community engagement campaigns
• Partnerships and collaborations
• Exchange listings
• Global marketing initiatives`
    },
    {
      label: 'Ecosystem Fund',
      percentage: '2.25%',
      color: 'bg-green-500',
      headerNote: '🔒 Locked & vested quarterly for 3 years',
      content: `Reserved for platform upgrades, emergency funds, collaborations, and other operational needs to ensure the long-term growth and sustainability of the ecosystem.`
    }
  ];

  return (
    <section className="container mx-auto px-4 py-12">
      <Card title="$EON Tokenomics Distribution" className="shadow-lg">
        <div className="grid md:grid-cols-2 gap-8 items-center">
          <div className="flex justify-center p-4">
            <Chart 
              type="doughnut" 
              data={chartData} 
              options={chartOptions} 
              className="w-full md:w-80" 
            />
          </div>

          <div className="space-y-6">
            <h3 className="text-2xl font-bold text-gray-800">
              Total Supply: 1,000,000,000 EON
            </h3>
            <p className="text-gray-600">
              EON serves as the lifeblood of the Eon Beasts ecosystem, powering NFT minting, evolution, marketplace activities, and AI Agent interactions. The tokenomics are designed for sustainable growth and community engagement.
            </p>

            <Accordion multiple>
              {allocationDetails.map((item, index) => (
                <AccordionTab 
                  key={index}
                  header={
                    <div className="flex items-center justify-between w-full">
                      <div className="flex items-center space-x-3">
                        <div className={`w-4 h-4 rounded-full ${item.color}`} />
                        <span className="font-semibold">{item.label}</span>
                        <span className="text-gray-500">{item.percentage}</span>
                      </div>
                      {item.headerNote && <span className="text-gray-400 text-sm">{item.headerNote}</span>}
                    </div>
                  }
                >
                  <div className="pl-7 text-gray-600 whitespace-pre-wrap">
                    {item.content}
                  </div>
                </AccordionTab>
              ))}
            </Accordion>
          </div>
        </div>

        <div className="mt-8 p-4 bg-blue-50 rounded-lg">
          <h4 className="text-lg font-semibold mb-3">⚡ Token Utility</h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex items-center space-x-3 p-3 bg-white rounded">
              <span className="text-2xl">🖼️</span>
              <span>NFT Minting & Evolution</span>
            </div>
            <div className="flex items-center space-x-3 p-3 bg-white rounded">
              <span className="text-2xl">🤖</span>
              <span>AI Agent Output Costs</span>
            </div>
            <div className="flex items-center space-x-3 p-3 bg-white rounded">
              <span className="text-2xl">🛒</span>
              <span>Marketplace Transactions</span>
            </div>
            <div className="flex items-center space-x-3 p-3 bg-white rounded">
              <span className="text-2xl">🎁</span>
              <span>Item Drop Upgrades</span>
            </div>
            <div className="flex items-center space-x-3 p-3 bg-white rounded">
              <span className="text-2xl">✨</span>
              <span>Cosmetic Upgrades</span>
            </div>
            <div className="flex items-center space-x-3 p-3 bg-white rounded">
              <span className="text-2xl">🎫</span>
              <span>Event Participation Fees</span>
            </div>
          </div>
        </div>
      </Card>
    </section>
  );
};

export default TokenomicsSection;
